// Copyright (c) 2016 Deere & Company

import ConfirmationModal, {getDefaultState} from '../../shared/state/confirmation-modal';
import actions from '../../action-list';

const resetConfirmationModal = () => {

    document.body.classList.remove('warranty-modal-is-open');

    return getDefaultState();

};

const setConfirmationModal = (state, action) => {

    document.body.classList.add('warranty-modal-is-open');

    return ConfirmationModal.update(state, {
        $set: action.data
    });

};

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL]: resetConfirmationModal,
        [actions.SET_CLAIM_ATTACHMENT_CONFIRMATION_MODAL]: setConfirmationModal
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/attachment/reducers/confirmation-modal.js